import { COST_BASIS_TYPES, UNIT_OF_TIME_TYPES } from 'views/DealDashboard/BOE/components/SlideoutForm/constants';

export const BOE_UNIT_TYPE_UI = {
    [COST_BASIS_TYPES.PER_SF]: 'SF',
    [COST_BASIS_TYPES.PER_UNIT]: 'unit',
    [COST_BASIS_TYPES.TOTAL]: 'SF',
};

export const LOAN_TERM_TIME = {
    [UNIT_OF_TIME_TYPES.MONTHLY]: 'month',
    [UNIT_OF_TIME_TYPES.YEARLY]: 'year',
};

export const infoTitleClass = 'text-uppercase text-primary my-1';
export const infoSubtitleRowClass = 'd-flex justify-content-between align-items-center mb-1';
export const infoValueClass = 'text-dark text-right';
export const cardRowClass = 'd-flex justify-content-between px-1';

export const BOE_TITLES = {
    PROPERTY_SIZE: 'Property size',
    INCOME: 'Income',
    EXPENSES: 'Expenses',
    EXIT_VALUE: 'Exit value',
    DEVELOPMENT_COSTS: 'Development costs',
    CONSTRUCTION_FINANCING: 'Construction financing',
    RETURNS: 'Returns',
};

export const BOE_SUBTITLES = {
    // Property size
    BUILT_GROSS_SF: 'Built gross SF',
    RETAIL_BUILT_GROSS_SF: 'Retail built gross SF',
    EFFICIENCY_RATIO: 'Efficiency ratio',
    RETAIL_EFFICIENCY_RATIO: 'Retail efficiency ratio',
    NET_RENTABLE_SF: 'Net rentable SF',

    // Income
    GROSS_POTENTIAL_RENT: 'Gross potential rent',
    UNITS: 'Units',
    SF_PER_UNIT: 'SF per unit',
    RETAIL_SUITES: 'Retail suites',
    RETAIL_SF_PER_SUITE: 'Retail SF per suite',

    // Expenses
    NET_OPERATING_INCOME: 'Net operating income',
    EXPENSES_TOTAL: 'Expenses total',
    RETAIL_EXPENSES_TOTAL: 'Retail expenses total',

    // Exit value
    EXIT_VALUATION: 'Exit valuation',
    ASSUMED_EXIT_CAP_RATE: 'Assumed exit cap rate',

    // Development costs
    TOTAL_DEVELOPMENT_COSTS: 'Total development costs',
    ACQUISITION_COSTS: 'Acquisition costs',
    HARD_COSTS: 'Hard costs',
    SOFT_COSTS: 'Soft costs',
    DEVELOPER_FEE: 'Developer fee',
    APR: 'APR',
    AVERAGE_LOAN_BALANCE: 'Average loan balance',
    LOAN_TERM: 'Loan term',
    INTEREST_RESERVE_TOTAL: 'Interest reserve total',

    // Construction financing
    LOAN_AMOUNT: 'Loan amount',
    REQUIRED_EQUITY: 'Required equity',
    LTC: 'LTC',
    LTV: 'LTV',
    DEBT_YIELD: 'Debt yield',

    // Returns
    RETURN_ON_COST: 'Return on cost',
    RETURN_ON_EQUITY: 'Return on equity',
    PROFIT_RETURN: 'Profit return',
};

export const HIGHLIGHTED_SUBTITLES = [
    BOE_SUBTITLES.GROSS_POTENTIAL_RENT,
    BOE_SUBTITLES.NET_OPERATING_INCOME,
    BOE_SUBTITLES.EXIT_VALUATION,
    BOE_SUBTITLES.TOTAL_DEVELOPMENT_COSTS,
    BOE_SUBTITLES.LOAN_AMOUNT,
    BOE_SUBTITLES.REQUIRED_EQUITY,
];
